// common.js

import GLightbox from 'glightbox/dist/js/glightbox.min.js';
import 'glightbox/dist/css/glightbox.min.css'; // GLightboxのCSSをインポート

document.addEventListener('DOMContentLoaded', function () {
    // GLightboxを初期化するための対象が存在するか確認
    const lightboxElements = document.querySelectorAll('.glightbox');
    if (lightboxElements.length > 0) {
        const lightbox = GLightbox({
            moreLength: 0,
            openEffect: 'fade',
            closeEffect: 'fade',
            slideEffect: 'fade',
            loop: true,
            width: '600px',
        });
    }

    var lightboxVideo;

    // GLightboxを初期化するための対象が存在するか確認
    const lightboxVideoElements = document.querySelectorAll('.glightbox-video');
    if (lightboxVideoElements.length > 0) {
        lightboxVideo = GLightbox({
            selector: '.glightbox-video'
        });

        lightboxVideo.on('slide_changed', ({ prev, current }) => {
            console.log('Prev slide', prev);
            console.log('Current slide', current);

            const { slideIndex, slideNode, slideConfig, player } = current;

            if (player) {
                if (!player.ready) {
                    // If player is not ready
                    player.on('ready', (event) => {
                        // Do something when video is ready
                    });
                }

                player.on('play', (event) => {
                    console.log('Started play');
                });

                player.on('volumechange', (event) => {
                    console.log('Volume change');
                });

                player.on('ended', (event) => {
                    console.log('Video ended');
                });
            }
        });

    }

    const toggleButtons = document.querySelectorAll('.submenu-toggle');

    toggleButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault(); // 親リンクの遷移を防ぐ
            const parentItem = button.closest('.p-mobile-menu__item');
            parentItem.classList.toggle('submenu-active'); // 子メニューの表示/非表示を切り替え
        });
    });

    // アンカーリンクのスクロール位置調整
    function scrollToTarget(hash, smooth = true) {
        const offset = 30;
        const target = document.querySelector(hash);
        if (target) {
            const rect = target.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetTop = rect.top + scrollTop - offset;
            
            window.scrollTo({
                top: targetTop,
                behavior: smooth ? 'smooth' : 'auto'
            });
        }
    }

    // ページ読み込み時のアンカーリンク処理
    if (window.location.hash) {
        // bodyを一時的に非表示
        document.body.style.opacity = '0';
        
        // 画像などを含む全てのリソースが読み込まれた後に実行
        window.addEventListener('load', function() {
            // スクロール位置を設定（アニメーションなし）
            scrollToTarget(window.location.hash, false);

            // フェードイン
            setTimeout(() => {
                document.body.style.transition = 'opacity 0.5s';
                document.body.style.opacity = '1';
            }, 100);
        });
    }

    // URLの変更（履歴）を監視 - こちらはスムーズスクロールのまま
    window.addEventListener('hashchange', function() {
        scrollToTarget(window.location.hash);
    });
});

// 名前付きエクスポートとしてcommon関数を定義
export const common = (message) => {
    console.log(message);
};

export default {}; // 空のオブジェクトをデフォルトエクスポート
